<!-- BaseSearchForm.vue (client) -->
<template tag="클라이언트 검색 폼 컴포넌트">
  <div class="search_input">
    <BaseInput v-model="model" type="search" :placeholder="placeholder" />
    <Base.Button icon="btn_search" txt="none">{{ $text("button.search") }}</Base.Button>
  </div>
</template>

<script setup lang="ts">
import { Base } from "@/common/base-components/BaseFactory.ts";

/* ------------------------------------------------------------
                          Vue Instance & Global Properties
   ------------------------------------------------------------ */
import { i18n } from "@/common/plugins/global";
const { $text } = i18n();

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<string>({ required: true });

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  placeholder: {
    type: String,
    default: "",
  },
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
/** 기본값 적용 */
const placeholder = props.placeholder ?? $text("message.searchPlaceholder");
</script>
